import { MarketingBanner } from '@barges/react';
import PropTypes from 'prop-types';
import React, { useState, useEffect } from 'react';
import { useTranslation, Trans } from 'react-i18next';
import { getDataFromStorage, toCamelCase } from '../config/utils';
import MarketingImage from './marketing_img/marketing_image';
import classes from './classes.module.scss';

import '@barges/scss/lib/title.css';
import '@barges/scss/lib/marketing-banner.css';

const TopBanner = ({
  topBannerProps
}) => {
  const {
    userBonusInfos = [], userXfmProgram = null, userId, anonymousUserBonusInfos, shouldShowMarketingBanner = true, isXFMActive, xfmFreeSetupMin, xfmDefaultMinutes, isPrerenderMode
  } = topBannerProps || {};
  const { t } = useTranslation();

  const [showTopBanner, setShowTopBanner] = useState(false);

  useEffect(() => {
    setTimeout(() => setShowTopBanner(true), 100);
  }, []);

  const shouldShowXFMBanner = () => {
    if (!isXFMActive) return false;
    if (userId) {
      return !!userXfmProgram?.credits;
    }
    const wasLoggedIn = !!getDataFromStorage('WAS_LOGIN');
    return !wasLoggedIn;
  };

  const freeMinutesText = () => {
    const minutesCount = xfmFreeSetupMin;
    const advisorsCount = userXfmProgram?.credits ?? xfmDefaultMinutes;

    const minutesText = minutesCount > 1 ? t('enjoy_free_minutes.minutes') : t('enjoy_free_minutes.minute');
    const advisorsText = advisorsCount > 1 ? t('enjoy_free_minutes.advisors') : t('enjoy_free_minutes.advisor');

    return (
      <Trans
        i18nKey= "enjoy_free_minutes.enjoy_free_minutes"
        values={ {
          minutesCount, advisorsCount, minutesText, advisorsText
        } }
      />
    );
  };

  const getActiveOffers = () => {
    if (userId) return userBonusInfos;
    if (anonymousUserBonusInfos) return anonymousUserBonusInfos;
    return window.bonus_infos ?? [];
  };

  const generateMarketingBannerArray = () => {
    if (!shouldShowMarketingBanner) return [];
    const activeOffers = getActiveOffers();
    let offers = [];
    if (activeOffers?.length > 0) {
      const offer = toCamelCase(activeOffers[0]);
      offers = [{ title: offer.specialOffer ?? '', subtitle: offer.bonusText  ?? '' }];
    }
    if (shouldShowXFMBanner()) {
      offers.push({ title: freeMinutesText() });
    }
    return offers;
  };

  const offers = generateMarketingBannerArray();

  if (!offers?.length || isPrerenderMode || !showTopBanner) return null;

  const getTopBannerContainerStyle = () => {
    if (offers?.length > 1) return {};
    return { maxHeight: '80px' };
  };

  return (
    <div className={ classes.topBannerContainer } style={ getTopBannerContainerStyle() }>
      <MarketingBanner
        offers={ offers }
        offerIcon={ <MarketingImage offers={ offers } /> }
      />
    </div>
  );
};

TopBanner.propTypes = {
  topBannerProps: PropTypes.object.isRequired
};

TopBanner.defaultProps = {};

export default TopBanner;
